module.exports = __webpack_public_path__ + "img/bg_festa2.b2199f3a.jpg";